// src/apiService.js
import axios from 'axios';
import API_BASE_URL from './apiConfig';

// Set up axios instance with default settings
const api: any = new Proxy({}, {
  get(target, prop) {
    const headers: any = {
      'Content-Type': 'application/json',
    };
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Create a new Axios instance with the updated headers
    const axiosInstance: any = axios.create({
      baseURL: API_BASE_URL,
      headers: headers,
    });

    // Return the method from the Axios instance (e.g., post, get, etc.)
    return axiosInstance[prop].bind(axiosInstance);
  }
});

const getAPI = (token: string) => {
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token || localStorage.getItem('token')}`
    },
  });
}

// Function to handle user creation
export const createUser = async (userData: any) => {
  try {
    const response = await api.post('/users', userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const getUsers = async (userData: any) => {
  try {
    const response = await api.get('/users');
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const authenticate = async (loginData: any) => {
  try {
    const response = await api.post('/users/login', loginData);
    return response.data;
  } catch (error: any) {
    if (error.status === 400) {
      throw new Error(error.response.data.message);
    }
    console.error('Error creating user:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get('/users/me');
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const updateUser = async (userData: any) => {
  try {
    const response = await api.put(`/users/${userData.id}`, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const forgotPassword = async (userData: any) => {
  try {
    const response = await api.post(`/users/forgotPassword`, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const resetPassword = async (data: any) => {
  try {
    const {token, password} = data;
    console.log('TOKEN', token);
    const response = await getAPI(token).post('/users/reset', {password});
    return response.data;
  } catch (error: any) {
    console.error('Error resetting password:', error);
    throw error.response;
  }
};
